import React from 'react';

import Loading2 from '../../../../components/Utility/LoadingSpinner/Loading';

/**
 * What a route shows while its chunk is on the wire.
 *
 * Every page in this app renders its own chrome (each one imports a Layout),
 * so a route boundary has no persistent shell to hold still around — the
 * fallback stands in for the whole page, exactly as the blank screen did
 * while the single 10 MB bundle was downloading. `Loading2` in its overlay
 * form is the app's existing full-page waiting state (share accept, magic
 * link verify, public entity pages all use it), so a route in flight looks
 * like every other wait the operator already knows, not a new one.
 */
const RouteSuspenseFallback: React.FC = () => <Loading2 />;

export default RouteSuspenseFallback;
